import React from 'react';
import moment from "moment";
import { connect } from 'react-redux';

import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';

import Toolbar from '../../../../components/toolbar/Toolbar';
import { Page } from '../../../../components/page/Page';
import MapViewRouteDialog from "../../../../components/map-view-route-dialog/MapViewRouteDialog";
import { HistoryLogListPage } from '../../../history-log-component';

import { routes } from '../../../../constants';

import * as IconFactory from '../../../../services/icons.factory';

import { actions } from '../cargo-shipment.actions';
// import { actions as driverActions } from '../../../driver/driver.actions';
import { actions as carrierActions } from '../../../carrier/carrier.actions';
import { actions as vehicleActions } from '../../../vehicle/vehicle.actions';
import { actions as vehicleTypeActions } from '../../../vehicleType/vehicleType.actions';
import { actions as actionsPortalCarrier } from '../../../portalCarrier/portalCarrier.actions';
import { actions as freightCalculationActions } from '../../../freightCalculation/freightCalculation.actions';
import { actions as orderManagementActions } from '../../../order-management/order-management.actions';


import * as utils from '../../../../utils';

import { CargoShipmentForm } from './CargoShipmentForm';
import "./CargoShipmentForm.scss";

const kgTemplate = (rowData, column) => {
    return (
        <span style={{ display: "inline-block", width: "100%", textAlign: "right" }}>{utils.formatNumber(rowData.cargo.summary.weight, 3)} KG</span>
    )
}
const valueTemplate = (rowData, column) => {
    return (
        <span style={{ display: "inline-block", width: "100%", textAlign: "right" }}>{utils.formatNumber(rowData.cargo.summary.value)}</span>
    )
}
const valueColTemplate = (rowData, column) => {
    return (
        <span style={{ display: "inline-block", width: "100%", textAlign: "right" }}>{utils.formatNumber(rowData[column.field])}</span>
    )
}
const shipmentCodeTemplate = (rowData, column) => {
    return (
        <span style={{ display: "inline-block", width: "100%", textAlign: "center" }}>{rowData.customFields.shipmentCode || ""}</span>
    )
}
const dateTimeTemplate = (rowData, column) => {
    const date = rowData[column.field];
    let formattedDate = moment(date).utc().format("DD/MM/YYYY HH:mm");
    return <span style={{ textAlign: "center" }}>{formattedDate}</span>;
};
const bodyIsAgTemplate = (rowData, column) => {
    let isAg = ""
    if (rowData[column.field]) {
        isAg = "AG"
    }

    return <span style={{ textAlign: "center" }}>{isAg}</span>;
};

const bodyNroNfeTemplate = (rowData, column) => {
    let nroNfe = rowData[column.field]

    return <span style={{ textAlign: "center" }}>{nroNfe}</span>;
};




function mapStateToProps(state) {

    const { 
        crudCargoShipmentState, 
        crudCarrierState, 
        // crudDriverState,
        crudVehicleState, 
        crudVehicleTypeState, 
        freightCalculationState
    } = state;
    const record = crudCargoShipmentState.currentRecord;
    const orderColumnsAux = crudCargoShipmentState.orderColumns;
    let orderColumns = [];
    const occurrenceColumns = crudCargoShipmentState.occurrenceColumns;
    const lookupCarrierBase = {
        records: crudCarrierState.records,
        columns: crudCarrierState.columns
            .filter(col => col.field === 'oid' || col.field === 'name' || col.field === 'tradeName')
            .map(col => {
                col = { ...col, sortable: false }
                return (<Column key={col.field} {...col} />)
            }),
        first: crudCarrierState.index,
        rows: crudCarrierState.max,
        totalRecords: crudCarrierState.count,
        sortField: crudCarrierState.sortField,
        order: crudCarrierState.sortOrder,
        editDisabled: !record.carrier,
        rowsPerPageOptions: [20, 50, 100],
    }
    let lookupCarrier = { ...state.crudCargoShipmentState.lookupCarrier, ...lookupCarrierBase };


    const lookupVehicleBase = {
        records: crudVehicleState.records,
        columns: crudCargoShipmentState.columnsVehicles
            .filter(col => col.field === 'driver.documentNumber' || col.field === 'plate' || col.field === 'vehicleType.name' || col.field === 'driver.name')
            .map(col => {
                col = { ...col}
                return (<Column key={col.field} {...col} />)
            }),
        first: crudVehicleState.index,
        rows: crudVehicleState.max,
        totalRecords: crudVehicleState.count,
        sortField: crudVehicleState.sortField,
        order: crudVehicleState.sortOrder,
        editDisabled: !record.driver,
        rowsPerPageOptions: [20, 50, 100],
    }

    let lookupVehicle = { ...state.crudCargoShipmentState.lookupVehicle, ...lookupVehicleBase }


    const lookupVehicleTypeBase = {
        records: crudVehicleTypeState.records,
        columns: crudVehicleTypeState.columns
            .filter(col => col.field === 'oid' || col.field === 'name' || col.field === 'code')
            .map(col => {
                col = { ...col, sortable: false }
                return (<Column key={col.field} {...col} />)
            }),
        first: crudVehicleTypeState.index,
        rows: crudVehicleTypeState.max,
        totalRecords: crudVehicleTypeState.count,
        sortField: crudVehicleTypeState.sortField,
        order: crudVehicleTypeState.sortOrder,
        editDisabled: !record.vehicleType,
        rowsPerPageOptions: [20, 50, 100],
    }

    let lookupVehicleType = { ...state.crudCargoShipmentState.lookupVehicleType, ...lookupVehicleTypeBase }

    const lookupOrderBase = {
        isMultiple: true,
        records: crudCargoShipmentState.orders,
        columns: crudCargoShipmentState.orderColumns
        .filter( col => col.field === 'code' || col.field === 'receiver.name' || col.field === 'receiver.address.city' || col.field === 'sender.name' || col.field === 'sender.address.city')
            .map(col => {
                col = { ...col, sortable: false, filter: true }
              
                return (<Column key={col.field} {...col} />)
            }),
        first: crudCargoShipmentState.lookupOrder.index,
        rows: crudCargoShipmentState.lookupOrder.max,
        totalRecords: crudCargoShipmentState.lookupOrder.count,
        sortField: crudCargoShipmentState.lookupOrder.sortField,
        order: crudCargoShipmentState.lookupOrder.sortOrder,
        rowsPerPageOptions: [20, 50, 100],
    }

    let lookupOrder = { ...state.crudCargoShipmentState.lookupOrder, ...lookupOrderBase }

    const status = (state.crudCargoShipmentState.currentRecord.status === "NEW" || state.crudCargoShipmentState.currentRecord.status === "APROVED" || state.crudCargoShipmentState.currentRecord.status === "TRAVELING") && state.crudCargoShipmentState.currentRecord.situation != "INVALID";
    const disableLookupVehicleType = status;
    const disableLookupCarrier = status;
    const disableLookupVehicle = status;
    let disableAddToolbarButton = status;
    let disableRemoveToolbarButton = status;
    const disabledForm = status;

    const quotesColumns = freightCalculationState.tableQuotes.columns
    const quotesRecords = state.freightCalculationState.tableQuotes.records.map(record => {
        const data = { ...record }
        data.carrierName = record && record.carrier ? record.carrier.name : "";
        return data
    })

    //libera o botao remover delivery quando for AG e o o embarque ja tiver sido aceito 
    if ((state.crudCargoShipmentState.currentRecord.status == "APROVED" || state.crudCargoShipmentState.currentRecord.status == "TRAVELING"
        || state.crudCargoShipmentState.currentRecord.status == "DELIVERED")
        && state.crudCargoShipmentState.currentRecord.situation != "INVALID"
        && crudCargoShipmentState.selectedOrders) {
        const orderSelected = crudCargoShipmentState.selectedOrders[0]
        if (orderSelected && orderSelected.ag == true) {
            disableRemoveToolbarButton = true;
        }
    }
    let isRemoveEmbarque = false
    let freightCombinedDisable = record.status === "NEW"
    if (record.status === "NEW" || record.status === "APROVED" || record.status === "TRAVELING" ) {
        isRemoveEmbarque = true
    }


    const { cargoManager = { permiteEmbarqueSemCotacao: false, freightCombined: false } } = state.crudAccountConfigurationState.currentRecord;

    if (cargoManager.freightCombined && record.freightCombinedCheck == true) {
        orderColumns = [...orderColumnsAux,
        {
            field: "freightCombined",
            header: "Frete Combinado",
            columnKey: "freightCombined",
            sortable: false,
            filter: false
        },
        ]
    } else {
        orderColumns = orderColumnsAux
    }
    const dialogMapViewRouteVisible = state.crudPortalCarrierState.dialogMapViewRouteVisible || false;
    const idEmbarqueShowMap = state.crudPortalCarrierState.idEmbarqueShowMap || null;

    return {
        selectedOrders: crudCargoShipmentState.selectedOrders,
        record,
        lookupCarrier,
        lookupVehicle,
        lookupVehicleType,
        lookupOrder,
        orderColumns,
        occurrenceColumns,
        disabledForm,
        disableLookupVehicleType,
        disableLookupCarrier,
        disableLookupVehicle,
        disableAddToolbarButton,
        disableRemoveToolbarButton,
        isRemoveEmbarque,
        rows: state.crudCargoShipmentState.max,
        first: state.crudCargoShipmentState.first,
        totalRecords: state.crudCargoShipmentState.count,
        sortField: state.crudCargoShipmentState.sortField,
        sortOrder: state.crudCargoShipmentState.sortOrder,
        totalWeight: state.crudCargoShipmentState.cards.totalWeight ? state.crudCargoShipmentState.cards.totalWeight : 0,
        totalValue: state.crudCargoShipmentState.cards.totalValue ? state.crudCargoShipmentState.cards.totalValue : 0,
        totalFreight: state.crudCargoShipmentState.cards.totalFreight ? state.crudCargoShipmentState.cards.totalFreight : 0,
        totalWeightVehicle: state.crudCargoShipmentState.cards.totalWeightVehicle ? state.crudCargoShipmentState.cards.totalWeightVehicle : 0,
        freightQuotesRecords: state.crudCargoShipmentState.freightQuotesRecords,
        quotesColumns,
        quotesRecords,
        deliveryStoColumns: crudCargoShipmentState.deliveryStoColumns,
        cargoManager,
        freightCombinedDisable,
        idEmbarqueShowMap,
        dialogMapViewRouteVisible
    }

}

function mapDispatchToProps(dispatch) {
    return {
        paginate: paginationParams => dispatch(actions.paginate(paginationParams)),
        sortOrder: sortParams => dispatch(actions.sortOrder(sortParams)),
        loadCargoShipmentById: (oid) => dispatch(actions.loadCargoShipmentById(oid)),
        saveHandler: event => {
            dispatch(actions.save());
        },
        removeHandler: event => {
            dispatch(actions.remove());
        },
        setCarrier: (carrier) => {
            const { name, documentNumber, branches } = carrier;
            const data = {
                name,
                cnpj: documentNumber,
                code: carrier.code || "",
                email: carrier.email || "",
                ownCarrier: carrier.ownCarrier || false
            }
            dispatch(actions.setField("carrier", data));
        },
        lookupCarrierApplyFilter: (filters) => {
            dispatch(carrierActions.setType(null));
            dispatch(carrierActions.applyFilter(filters))
        },
        lookupCarrierSetVisible: (visible) => {
            dispatch(actions.lookupCarrierSetVisible(visible));
        },
        lookupCarrierSortOrder: (params) => {
            dispatch(carrierActions.sortOrder(params));
        },
        lookupCarrierPaginate: (params) => {
            dispatch(carrierActions.paginate(params));
        },

        /* VEHICLE - loockup que mostra o motorista com base no tipo de veiculo escolhido*/
        setVehicle: (vehicle) => {
            const { driver, plate } = vehicle
            const driverSelected = {
                "documentNumber": driver.documentNumber,
                "name": driver.name
            }
            dispatch(actions.setField("driver", driverSelected));
            dispatch(actions.setField("vehicle.plate", plate || ""));

        },
        lookupVehicleApplyFilter: (filters) => {
            dispatch(vehicleActions.setType(null));
            dispatch(vehicleActions.applyFilter(filters))
        },
        lookupVehicleSetVisible: (visible) => {
            dispatch(actions.lookupVehicleSetVisible(visible));
        },
        lookupVehicleSortOrder: (params) => {
            dispatch(vehicleActions.sortOrder(params));
        },
        lookupVehiclePaginate: (params) => {
            dispatch(vehicleActions.paginate(params));
        },



        /* VEHICLE TYPE */
        setVehicleType: (vehicleType) => {
            const { name, code = "", pallets = 0, averageSpeed = 0, weight = 0 } = vehicleType

            const vehicle = {
                vehicleCapacity: pallets,
                averageSpeed, weight,
                plate: "",
                vehicleType: {
                    "name": name,
                    "label": code
                }
            }

            dispatch(actions.setField("vehicle", vehicle));
            dispatch(actions.setField("driver", { documentNumber: "", name: "" }));
        },
        lookupVehicleTypeApplyFilter: (filters) => {
            dispatch(vehicleTypeActions.setType(null));
            dispatch(vehicleTypeActions.applyFilter(filters))
        },
        lookupVehicleTypeSetVisible: (visible) => {
            dispatch(actions.lookupVehicleTypeSetVisible(visible));
        },
        lookupVehicleTypeSortOrder: (params) => {
            dispatch(vehicleTypeActions.sortOrder(params));
        },
        lookupVehicleTypePaginate: (params) => {
            dispatch(vehicleTypeActions.paginate(params));
        },
        setField: (field, value) => {
            dispatch(actions.setField(field, value));
        },
        setSelectedOrders: (orders) => {
            dispatch(actions.setSelectedOrders(orders));
        },
        onRemoveSelectedOrder: () => {
            dispatch(actions.removeSelectedOrders());
            dispatch(actions.calcCards());
        },

        /* LOOKUP ORDER */
        setLookupOrderVisible: (visible) => {
            dispatch(actions.setLookupOrderVisible(visible))
        },
        loadOrders: () => {
            dispatch(actions.loadOrders());
        },
        apllyOrderFilters: (filters) => {
            dispatch(actions.setOrderFilters(filters));
        },
        addOrders: (orders) => {
            dispatch(actions.addOrders(orders));
        },
        lookupOrderPaginate: (params) => {
            dispatch(actions.lookupOrderPaginate(params));
        },
        lookupOrderSortOrder: (params) => {
            dispatch(actions.lookupOrderSortOrder(params));
        },

        calcCards: () => {
            dispatch(actions.calcCards());
        },

        loadQuotes: (params) => {
            dispatch(freightCalculationActions.apiCalculateFreight(params));
        },

        clearfreightCalculationQuotes: () => {
            dispatch(freightCalculationActions.clearQuotes([]));
        },
        setStandardFreight: () => {
            dispatch(actions.setStandardFreight());
        },
        setFreightCombinedCheck: (freightCombinedCheck) => {
            // dispatch(actions.setField("freightCombinedCheck", freightCombinedCheck))
            dispatch(actions.setFreightCombinedCheck(freightCombinedCheck))
        },
        setFreightCombinedShipment: (freightCombinedShipment) => {
            dispatch(actions.setFreightCombinedShipment(freightCombinedShipment))
        },
        calculateCargoShipmentWithFreightCombinedOrder: (orderCode, freightCombinedOrder) => {
            dispatch(actions.calculateCargoShipmentWithFreightCombinedOrder(orderCode, freightCombinedOrder))
        },
        setFreightCombinedOrder: (freightCombinedOrder, orderCode) => {
            dispatch(actions.setFreightCombinedOrder(freightCombinedOrder, orderCode))
        },
        calcFreightCombinedOrders: (freightCombinedShipment) => {
            dispatch(actions.setCalcFreightCombinedOrdersWithShipmentFreight(freightCombinedShipment))
        },
        setFreightTotaValue: () => {
            dispatch(actions.setFreightTotaValue())
        },
        setVisibleDialogMapViewRoute: (visible) => dispatch(actionsPortalCarrier.setVisibleDialogMapViewRoute(visible)),
        setIdEmbarToViewRouteOnMap: (idEmbarqueShowMap) => dispatch(actionsPortalCarrier.setIdEmbarToViewRouteOnMap(idEmbarqueShowMap)),

    }
}

class CargoShipmentFormPageContainer extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            isVisibleHistorylog: false,
            isVisibleDeliveryReceipt: false,
            isVisibleModalFreightQuote: false,
            spin: false,
            currentImagePath: '',
            countRotation: 0,
        }
    }

    componentDidMount() {
        const oid = this.props.match.params.id;
        if (oid && parseInt(oid)) {
            this.props.loadCargoShipmentById(oid);
        }
        this.props.loadOrders();
        this.props.calcCards();
    }

    searchHandler = () => {
        this.props.history.push(`${routes.PATH_ORDER_MANAGEMENT}`)
    }

    onRemoveHandler = () => {
        this.props.removeHandler()
        
        setTimeout(() => {
            this.props.history.push(`${routes.PATH_ORDER_MANAGEMENT}`);
        }, 5000);
        
    }

    lookupCarrierOnInputFilter = (e) => {
        const value = e.value;
        let filters = []
        if (typeof value === 'string') {
            filters.push({
                campo: "name",
                valor: value,
                tipoFiltro: 'CONTEM'
            });
            this.props.setCarrier({ name: value });
        } else {
            this.props.setCarrier(value);
        }
        this.props.lookupCarrierApplyFilter(filters);
    }
    lookupCarrierOnClick = () => {
        const filters = [];
        this.props.lookupCarrierPaginate({
            max: 15,
            index: 0
        });
        this.props.lookupCarrierApplyFilter(filters);
        this.props.lookupCarrierSetVisible(true);

    }
    lookupCarrierOnHide = () => {
        this.props.lookupCarrierSetVisible(false);
    }
    lookupCarrierOnConfirm = (event) => {
        this.props.setCarrier(event.selection);
        this.props.lookupCarrierSetVisible(false);
    }
    lookupCarrierOnFilter = (e) => {
        const filters = [];
        const keys = Object.keys(e.filters) || [];
        keys.forEach(key => {
            filters.push({
                campo: key,
                valor: e.filters[key].value,
                tipoFiltro: 'CONTEM'
            });
        });
        this.props.lookupCarrierApplyFilter(filters);
    }
    lookupCarrierOnSort = (e) => {
        this.props.lookupCarrierSortOrder({
            sortOrder: e.sortOrder,
            sortField: e.sortField
        });
    }
    lookupCarrierOnPage = (e) => {
        this.props.lookupCarrierPaginate({
            max: e.rows,
            index: e.first
        });
    }

    /* VEHICLE */
    lookupVehicleOnEdit = () => { };
    lookupVehicleOnComplete = (e) => { };
    lookupVehicleOnInputFilter = (e) => {
        const value = e.value;
        let filters = []
        if (typeof value === 'string') {
            filters.push({
                campo: "name",
                valor: value,
                tipoFiltro: 'CONTEM'
            });
            this.props.setVehicle({ name: value });
        } else {
            this.props.setVehicle(value);
        }
        this.props.lookupVehicleApplyFilter(filters);
    }
    lookupVehicleOnClick = () => {
        const filters = [];
        filters.push({
            campo: "vehicleType.label",
            valor: this.props.record.vehicle.vehicleType.label,
            tipoFiltro: 'IGUAL_A'
        });
        this.props.lookupVehiclePaginate({
            max: 15,
            index: 0
        });
        this.props.lookupVehicleApplyFilter(filters);
        this.props.lookupVehicleSetVisible(true);

    }
    lookupVehicleOnHide = () => {
        this.props.lookupVehicleSetVisible(false);
    }
    lookupVehicleOnConfirm = (event) => {
        this.props.setVehicle(event.selection);
        this.props.lookupVehicleSetVisible(false);
    }
    lookupVehicleOnFilter = (e) => {
        const filters = [];
        const keys = Object.keys(e.filters) || [];
        keys.forEach(key => {
            filters.push({
                campo: key,
                valor: e.filters[key].value,
                tipoFiltro: 'CONTEM'
            });
        });
        this.props.lookupVehicleApplyFilter(filters);
    }
    lookupVehicleOnSort = (e) => {
        this.props.lookupVehicleSortOrder({
            sortOrder: e.sortOrder,
            sortField: e.sortField
        });
    }
    lookupVehicleOnPage = (e) => {
        this.props.lookupVehiclePaginate({
            max: e.rows,
            index: e.first
        });
    }
    lookupVehicleOnCancel = (e) => {
        this.props.setVehicle(null);
        this.props.lookupVehicleSetVisible(false);
    };


    /** VEHICLE TYPE */
    lookupVehicleTypeOnInputFilter = (e) => {
        const value = e.value;
        let filters = []
        if (typeof value === 'string') {
            filters.push({
                campo: "name",
                valor: value,
                tipoFiltro: 'CONTEM'
            });
            this.props.setVehicleType({ name: value });
        } else {
            this.props.setVehicleType(value);
        }
        this.props.lookupVehicleTypeApplyFilter(filters);
    }
    lookupVehicleTypeOnClick = () => {
        const filters = [];
        this.props.lookupVehicleTypePaginate({
            max: 15,
            index: 0
        });
        this.props.lookupVehicleTypeApplyFilter(filters);
        this.props.lookupVehicleTypeSetVisible(true);

    }
    lookupVehicleTypeOnHide = () => {
        this.props.lookupVehicleTypeSetVisible(false);
    }
    lookupVehicleTypeOnConfirm = (event) => {
        // console.log("VehicleType.selection:", event.selection)
        this.props.setVehicleType(event.selection);
        this.props.lookupVehicleTypeSetVisible(false);
    }
    lookupVehicleTypeOnFilter = (e) => {
        const filters = [];
        const keys = Object.keys(e.filters) || [];
        keys.forEach(key => {
            filters.push({
                campo: key,
                valor: e.filters[key].value,
                tipoFiltro: 'CONTEM'
            });
        });
        this.props.lookupVehicleTypeApplyFilter(filters);
    }
    lookupVehicleTypeOnSort = (e) => {
        this.props.lookupVehicleTypeSortOrder({
            sortOrder: e.sortOrder,
            sortField: e.sortField
        });
    }
    lookupVehicleTypeOnPage = (e) => {
        this.props.lookupVehicleTypePaginate({
            max: e.rows,
            index: e.first
        });
    }


    onChangeHandler = (event) => {
        const target = event.target;
        const value = target.value;
        const name = target.name;
        this.props.setField(name, value);
    }
    onChangeHandlerFreightCombinedShipment = (event) => {
        try {
            let value = parseFloat(event.target.value)
            this.props.setFreightCombinedShipment(value);
            this.props.calcFreightCombinedOrders(value)
            this.props.setFreightTotaValue();
        } catch (error) {
            console.log("error: ", error)
        }
        // action para atualizar o valor do frete dos pedidos
    }
    onChangeHandlerFreightCombinedOrder = (e, order) => {
        if (order.code) {
            let value = parseFloat(e.target.value)
            this.props.setFreightCombinedOrder(value, order.code)
            this.props.calculateCargoShipmentWithFreightCombinedOrder(order.code, value)
        }
    }
    onChangeHandlerFreightCombinedCheck = (event) => {
        // if(!event.target.value || event.target.value == "undefined"){
        //     this.props.calcCards();
        //     // this.props.setStandardFreight();
        // }
        this.props.setFreightCombinedCheck(event.target.value);
    }

    ordersOnSelectionChange = (event) => {
        this.props.setSelectedOrders(event.value);
    }


    /* LOOKUP ORDER */

    lookupOrderOnHide = () => {
        this.props.setLookupOrderVisible(false);
        this.props.apllyOrderFilters([]);
    }

    lookupOrderOnConfirm = (event) => {
        this.props.addOrders(event.selection);
        this.props.setLookupOrderVisible(false);
        this.props.apllyOrderFilters([]);
        this.props.calcCards();

    }

    lookupOrderOnPage = (e) => {
        this.props.lookupOrderPaginate({
            max: e.rows,
            index: e.first
        });
        this.props.loadOrders();
    }

    lookupOrderOnSort = (e) => {
        this.props.lookupOrderSortOrder({
            sortOrder: e.sortOrder,
            sortField: e.sortField
        });
    }
    lookupOrderOnFilter = (e) => {
        const filters = [];
        const keys = Object.keys(e.filters) || [];
        keys.forEach(key => {
            filters.push({
                campo: key,
                valor: e.filters[key].value,
                tipoFiltro: 'CONTEM'
            });
        });
        this.props.apllyOrderFilters(filters);
    }
    

    dialogAddOrderShow = () => {
        this.props.apllyOrderFilters([]);
        this.props.loadOrders();
        this.props.setLookupOrderVisible(true);
    }

    occurrencesOnPage = e => {
        this.props.paginate({
            max: e.rows,
            index: e.first
        });
    };
    occurrencesOnSort = e => {
        this.props.sortOrder({
            sortOrder: e.sortOrder,
            sortField: e.sortField
        });
    };

    onClickOpenHistoryLog = () => {
        this.setState({
            isVisibleHistorylog: true
        })
    }
    onHideHistorylog = () => {
        this.setState({
            isVisibleHistorylog: false
        })
    }

    showDeliveryReceiptOnClick = (visible) => {
        this.setState({
            isVisibleDeliveryReceipt: visible
        });
    }

    onShowModalFreightQuoteOnClick = (visible) => {
        this.setState({
            isVisibleModalFreightQuote: visible
        });
    }

    onShowFreightQuote = () => {
        this.onLoadQuotes();
        this.onShowModalFreightQuoteOnClick(true);
    }

    onOpenCargoShipOnMapa = () => {
        this.props.setIdEmbarToViewRouteOnMap(this.props.record.oid);
        this.props.setVisibleDialogMapViewRoute(true);
    }

    changeTransiction = () => {
        let count = this.state.countRotation;
        let cssClassName = 'rotate-image-carg';
        if (count == 0) {
            cssClassName = cssClassName + ' spin';
            count++;
        } else if (count == 1) {
            cssClassName = cssClassName + ' spin180-carg';
            count++;
        } else if (count == 2) {
            cssClassName = cssClassName + ' spin360-carg';
            count = 0;
        }

        this.setState({ countRotation: count })

        this.setState((prevState) => {
            const spin = !prevState.spin;
            return {
                spin,
                image: (<img className={cssClassName} src={prevState.currentImagePath} />)
            }
        })
    }

    setCurrentImage = (image) => {
        const path = `${image}`//data:image/jpeg;base64,
        const spin = !!this.state.spin;
        image = (<img className={utils.classNames({ 'rotate-image-carg': true, 'spin': spin })} src={path} />)
        this.setState({
            spin,
            currentImagePath: path,
            image
        });
    }

    onLoadQuotes = () => {
        let weight = 0;
        let value = 0;
        this.props.record.orders.forEach((item) => {
            weight += item.cargo.summary.weight;
            value += item.cargo.summary.value;
        });

        let zipCodeDestination = this.props.record.destination.address.zipcode || "";
        zipCodeDestination = zipCodeDestination.replace("-", "");
        let zipCodeOrigin = this.props.record.origin.address.zipcode || ""
        zipCodeOrigin = zipCodeOrigin.replace("-", "");


        const body = {
            currentLocationTypeFilter: "",
            freightCalculationParams: {
                zipCodeDestination: parseInt(zipCodeDestination),
                zipCodeOrigin: parseInt(zipCodeOrigin),
                weight: parseFloat(weight),
                value: parseFloat(value),
                distance: parseFloat(this.props.record.distance),
                vehicleType: this.props.record.vehicle.vehicleType,
                clientCNPJ: null,
                deliveryNumbers: this.props.record.deliveryNumbers,
                shipper: this.props.record.shipper.documentNumber || "",
            },

        }
        this.props.loadQuotes(body);
    };



    freightCombinedTemplate = (rowData, column) => {
        let valor = 0
        try {
            valor = parseFloat(rowData.freightCombinedOrder)
            if (valor === NaN) {
                valor = 0
            }
        } catch (error) {
            console.log("valor: ", rowData.freightCombinedOrder, " erro: ", error)
            valor = 0
        }

        return <InputText disabled={!this.props.freightCombinedDisable} type="number" placeholder="0.0" style={{ width: "100%" }} value={valor} onChange={(e) => this.onChangeHandlerFreightCombinedOrder(e, rowData)} name="freightCombinedOrder" />
    };

    render() {
        const title = `Embarque ${this.props.record.oid || 'novo'}`
        const header = (
            <div>
                <h1>{title}</h1>
                <hr className="lxSplitter" ></hr>
                <div>
                    <Toolbar
                        onSave={this.props.saveHandler}
                        saveButtonStyle='highlighted'
                        onRemove={this.props.record.status && this.props.isRemoveEmbarque ? this.onRemoveHandler : ""}
                        removeButtonStyle='danger'
                        onSearch={this.searchHandler}
                        onShowHistoryLog={this.props.record.oid ? this.onClickOpenHistoryLog : null}
                        onShowFreightQuote={this.props.record.oid ? this.onShowFreightQuote : null}
                        onOpenCargoShipOnMapa={this.props.record.oid ? this.onOpenCargoShipOnMapa : null}
                        messageDelete="Deseja realmente remover o embarque?"
                        counter={this.props.record.code && this.props.record.code.length > 0}
                        disableBtnDelete={this.props.record.status === "TRAVELING" ? true : false}
                        disableBtnFreightQuote={true}
                    >

                    </Toolbar>
                </div>
            </div>
        );

        let orderColumns = [<Column key="selectorColumn" selectionMode="multiple" style={{ width: '3em' }} />];
        orderColumns = [...orderColumns, ...this.props.orderColumns.map(col => {

            if (col.field === "cargo.summary.weight") {
                return (<Column key={col.field} {...col} body={kgTemplate} />)
            }
            if (col.field === "code") {
                return (<Column key={col.field} {...col} style={{ width: "150px" }} />)
            }
            if (col.field === "freightCombined") {
                return (<Column key={col.field} {...col} style={{ width: "100px" }} body={this.freightCombinedTemplate} />)
            }
            if (col.field === "cargo.summary.value") {
                return (<Column key={col.field} {...col} body={valueTemplate} />)
            }
            if (col.field === "customFields.shipmentCode") {
                return (<Column key={col.field} {...col} body={shipmentCodeTemplate} />)
            }
            if (col.field === "apportionmentValue") {
                return (<Column key={col.field} {...col} body={valueColTemplate} />)
            }

            if (col.field === "deliveryForecast") {
                return (<Column key={col.field} {...col} body={dateTimeTemplate} />)
            }
            if (col.field === "ag") {
                return (<Column key={col.field} {...col} style={{ width: "60px" }} body={bodyIsAgTemplate} />)
            }
            if (col.field === "nfeNumber") {
                return (<Column key={col.field} {...col} style={{ width: "70px" }} body={bodyNroNfeTemplate} />)
            }
            return (<Column {...col} key={col.field} />)
        })];

        const lookupVehicleType = {
            fields: {
                editDisabled: true,
                ...this.props.lookupVehicleType,
            },
            actions: {
                onComplete: () => { },
                onInputFilter: this.lookupVehicleTypeOnInputFilter,
                onEdit: () => { },
                onClick: this.lookupVehicleTypeOnClick,
                onHide: this.lookupVehicleTypeOnHide,
                onConfirm: this.lookupVehicleTypeOnConfirm,
                onCancel: this.lookupVehicleTypeOnHide,
                onPage: this.lookupVehicleTypeOnPage,
                onFilter: this.lookupVehicleTypeOnFilter,
                onSort: this.lookupVehicleTypeOnSort,
                disabled: !this.props.disableLookupVehicleType
            }
        }
        const lookupCarrier = {
            fields: {
                editDisabled: true,
                ...this.props.lookupCarrier,
            },
            actions: {
                onComplete: () => { },
                onInputFilter: this.lookupCarrierOnInputFilter,
                onEdit: () => { },
                onClick: this.lookupCarrierOnClick,
                onHide: this.lookupCarrierOnHide,
                onConfirm: this.lookupCarrierOnConfirm,
                onCancel: this.lookupCarrierOnHide,
                onPage: this.lookupCarrierOnPage,
                onFilter: this.lookupCarrierOnFilter,
                onSort: this.lookupCarrierOnSort,
                disabled: !this.props.disableLookupCarrier
            }
        }
        const lookupVehicle = {
            fields: {
                editDisabled: true,
                ...this.props.lookupVehicle,
            },
            actions: {
                onComplete: this.lookupVehicleOnComplete,
                onInputFilter: this.lookupVehicleOnInputFilter,
                onEdit: this.lookupVehicleOnEdit,
                onClick: this.lookupVehicleOnClick,
                onHide: this.lookupVehicleOnHide,
                onConfirm: this.lookupVehicleOnConfirm,
                onCancel: this.lookupVehicleOnHide,
                onPage: this.lookupVehicleOnPage,
                onFilter: this.lookupVehicleOnFilter,
                onSort: this.lookupVehicleOnSort,
                disabled: !this.props.disableLookupVehicle
            }
        }

        const orders = {
            toolbar: {
                hint: {
                    add: "Adicionar pedido",
                    remove: "Remover pedido",
                },
                header: "Pedidos",
                onAdd: this.dialogAddOrderShow,
                onRemove: this.props.onRemoveSelectedOrder,
                disabledButtonOrders: {
                    add: !this.props.disableAddToolbarButton,
                    remove: !this.props.disableRemoveToolbarButton
                }
            },
            table: {
                dataTable: {
                    selection: this.props.selectedOrders ? this.props.selectedOrders : [],
                    value: this.props.record && this.props.record.orders ? this.props.record.orders : [],
                    sortOrder: 0,
                    sortField: "",
                    paginator: true,
                    selectionMode: "multiple",
                    rows: this.props.tableOrders && this.props.tableOrders.rows ? this.props.tableOrders.rows : 5,
                    onSelectionChange: this.ordersOnSelectionChange ? this.ordersOnSelectionChange : () => { console.log("datatable.ordersOnSelectionChange must be implemented") },
                    onFilter: this.ordersOnFilter ? this.ordersOnFilter : () => { console.log("ordersOnFilter must be implemented") },
                    onSort: this.ordersOnSort ? this.ordersOnSort : () => { console.log("ordersOnSort must be implemented") },
                    emptyMessage: "Não foram encontrados registros",
                    rowsPerPageOptions: [5, 10, 20, 50]
                },
                columns: [...orderColumns]
            }
        }
        const lookupOrder = {
            fields: {
                ...this.props.lookupOrder
            },
            actions: {
                onHide: this.lookupOrderOnHide,
                onConfirm: this.lookupOrderOnConfirm,
                onCancel: this.lookupOrderOnHide,
                onPage: this.lookupOrderOnPage,
                onFilter: this.lookupOrderOnFilter,
                onSort: this.lookupOrderOnSort,
                
            }
        }

        const dateTemplate = (rowData, column) => {
            const date = rowData[column.field];
            let formattedDate = moment(date).utc().format("DD/MM/YYYY");
            return <div style={{ textAlign: "center" }}>{formattedDate}</div>;
        };

        const occurrenceTypeCodeWithOccurrenceTypeDescriptionTemplate = (rowData, column) => {
            const occurrenceText = `${rowData.occurrenceType} - ${rowData.occurrenceTypeDescription}`;
            return <span style={{ textAlign: "center" }}>{occurrenceText}</span>;
        }



        const imageTemplate = (rowData, column) => {
            const image = rowData[column.field] || null;
            // if ((rowData.code === 1 || rowData.code === 9999) && image) {
            if (image) {
                return <div className="p-col-12 lxActionButtons" style={{ textAlign: "center" }}>
                    <button
                        className="lognex-btn-highlighted"
                        onClick={(e) => {
                            this.setCurrentImage(image)
                            this.showDeliveryReceiptOnClick(true);
                        }}
                        title={"Ver comprovante de entrega"}
                    >
                        <i className="pi pi-image"></i>
                    </button>
                </div>
            } else {
                return ""
            }
        }

        let occurrenceColumns = [<Column key="selectorColumn" style={{ textAlign: "center", width: '3em' }} />];
        occurrenceColumns = [...occurrenceColumns, ...this.props.occurrenceColumns.map(col => {
            if (col.field === "dateOccurrence") {
                return (<Column key={col.field} {...col} body={dateTemplate} />)
            }
            if (col.field === "image") {
                return (<Column key={col.field} {...col} body={imageTemplate} />)
            }
            if (col.field === "code") {
                return (<Column key={col.field} {...col} body={occurrenceTypeCodeWithOccurrenceTypeDescriptionTemplate} />);
            }
            return (<Column style={{ textAlign: "center" }} {...col} key={col.field} />)
        })];

        const valueTemplateDeliverySto = (rowData, column) => {
            return (
                <span style={{ display: "inline-block", width: "100%", textAlign: "right" }}>{utils.formatNumber(rowData.cargo.summary.value)}</span>
            )
        }

        let deliveryStoColumns = this.props.deliveryStoColumns.map(col => {
            if (col.field === "deliveryForecast") {
                return (<Column key={col.field} {...col} body={dateTimeTemplate} />)
            }
            if (col.field === "cargo.summary.value") {
                return (<Column key={col.field} {...col} body={valueTemplateDeliverySto} />)
            }
            if (col.field === "apportionmentValue") {
                return (<Column key={col.field} {...col} body={valueColTemplate} />)
            }
            return (<Column style={{ textAlign: "center" }} {...col} key={col.field} />)
        });

        const occurrences = {
            columns: [...occurrenceColumns],
            records: this.props.record.occurrences,
        }
        const deliverysSto = {
            columns: deliveryStoColumns,
            records: this.props.record.ordersByTransfer || [],
        }

        const modalViewDeliveryReceipt = {
            title: "Comprovante de Entrega",
            visible: this.state.isVisibleDeliveryReceipt,
            image: this.state.image,
            onHide: () => this.showDeliveryReceiptOnClick(false),
        }

        const currencyTemplate = (rowData, column) => {
            return (
                <div style={{ textAlign: 'center' }}>{utils.numberToCurrency(rowData[column.field], 'REAL')}</div>
            )
        }
        const percentTemplate = (rowData, column) => {
            return (
                <div style={{ textAlign: 'center' }}> {utils.formatNumber(rowData[column.field])}</div>
            )
        }
        const tagsTemplate = (rowData, column) => {
            const tags = rowData[column.field] && rowData[column.field].length > 0 ? rowData[column.field].join(', ') : ""
            return (
                <div style={{ textAlign: 'center' }}> {tags}</div>
            )
        }

        const deadlineTemplate = (rowData, column) => {
            return (
                <div style={{ textAlign: 'center' }}> {utils.formatNumber(rowData[column.field])}<span title="dias">{' d'}</span></div>
            )
        }
        const workingDaysTemplate = (rowData, column) => {
            const result = rowData[column.field];
            return <div style={{ textAlign: 'center' }}>{result === true ? 'Úteis' : result === false ? 'Todos' : ''}</div>;
        };

        const applyColumnsCustomBodies = (columns) => {
            return columns.map(col => {
                if (col.columnKey === 'freightValue' || col.columnKey === 'icmsValue' || col.columnKey === 'totalFreightValue') {
                    col.body = currencyTemplate
                } else if (col.columnKey === 'carrierDeliveryDeadline' || col.columnKey === 'clientDeliveryDeadline') {
                    col.body = deadlineTemplate
                } else if (col.columnKey === 'nfePercent') {
                    col.body = percentTemplate
                } else if (col.columnKey === 'tags') {
                    col.body = tagsTemplate
                } else if (col.columnKey === 'onlyWorkingDays') {
                    col.body = workingDaysTemplate
                }
                return col
            })
        }

        const headerTemplate = (iconName, col, label = false) => {
            return (
                <div className="iconTemplate">
                    <span>
                        <img src={IconFactory.getIcon(iconName)}
                            title={col.header} alt={col.header} />
                    </span>
                    <span>
                        {label ? col.header : ""}
                    </span>
                </div>)
        }

        const applyColumnsCustomHeaderBodies = (columns) => {
            return columns.map(col => {
                if (col.columnKey === 'carrierDeliveryDeadline') {
                    col.headerBody = headerTemplate("clock_truck", col)
                } else if (col.columnKey === 'clientDeliveryDeadline') {
                    col.headerBody = headerTemplate("clock_person", col)
                } else if (col.columnKey === 'tags') {
                    col.headerBody = headerTemplate("mark", col)
                } else if (col.columnKey === 'onlyWorkingDays') {
                    col.headerBody = headerTemplate("calendar", col)
                }
                return col
            })
        }

        let columns = applyColumnsCustomBodies(this.props.quotesColumns)
        columns = applyColumnsCustomHeaderBodies(this.props.quotesColumns)

        const modalFreightQuote = {
            title: "Cálculo de Frete",
            visible: this.state.isVisibleModalFreightQuote,
            columns: columns,
            value: this.props.quotesRecords,
            onHide: () => {
                this.props.clearfreightCalculationQuotes();
                this.onShowModalFreightQuoteOnClick(false)
            },
        }
        const getMapViewRouteDialog = () => {
            if (this.props.dialogMapViewRouteVisible) {
                return <MapViewRouteDialog
                    dialogMapViewRouteVisible={this.props.dialogMapViewRouteVisible}
                    idEmbarqueShowMap={this.props.idEmbarqueShowMap}
                    onHideDialog={(e) => {
                        this.props.setVisibleDialogMapViewRoute(false);
                    }} />
            }
            return <></>
        }

        const content = (<div>
            <CargoShipmentForm
                weight={this.props.totalWeight}
                value={this.props.totalValue}
                freightValue={this.props.totalFreight}
                totalWeightVehicle={this.props.totalWeightVehicle}
                record={this.props.record}
                changeHandler={this.onChangeHandler}
                changeHandlerFreightCombinedShipment={this.onChangeHandlerFreightCombinedShipment}
                changeHandlerFreightCombinedCheck={this.onChangeHandlerFreightCombinedCheck}
                lookupVehicleType={lookupVehicleType}
                lookupVehicle={lookupVehicle}
                lookupCarrier={lookupCarrier}
                lookupOrder={lookupOrder}
                orders={orders}
                occurrences={occurrences}
                modal={modalViewDeliveryReceipt}
                changeTransiction={this.changeTransiction}
                disabledForm={this.props.disabledForm}
                modalFreightQuote={modalFreightQuote}
                deliverysSto={deliverysSto}
                freightCombinedDisable={this.props.freightCombinedDisable}
                freightCombinedConfiguration={this.props.cargoManager.freightCombined}
            />

            {this.state.isVisibleHistorylog &&
                <HistoryLogListPage docID={this.props.record.oid} resourceType={"cargo_shipment"} onHide={this.onHideHistorylog} />
            }
            {getMapViewRouteDialog()}

        </div>)
        return (<Page header={header} content={content} />)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CargoShipmentFormPageContainer)